export default function AuthenticationLayout({children}) {
  return (
    <div id="layoutAuthentication" className="bg-primary">
      <div id="layoutAuthentication_content">
        <main>
          <div className="container-xl px-4">
            <div className="row justify-content-center">
              {children}
            </div>
          </div>
        </main>
      </div>
      <div id="layoutAuthentication_footer">
        {/*  <footer className="footer-admin mt-auto footer-dark">*/}
        {/*    <div className="container-xl px-4">*/}
        {/*      <div className="row">*/}
        {/*        <div className="col-md-6 small">Copyright &copy; Zetta 2024</div>*/}
        {/*        <div className="col-md-6 text-md-end small">*/}
        {/*          <a href="#!">Privacy Policy</a>*/}
        {/*          &middot;*/}
        {/*          <a href="#!">Terms &amp; Conditions</a>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </footer>*/}
      </div>
    </div>
  )
}
